import { ComponentProps } from "react";
import cn from "classnames";

import styles from "./AscRosteringTypeCard.module.scss";

export interface AscRosteringTypeCardProps extends ComponentProps<"button"> {
  title: string;
  subtitle: string;
  active: boolean;
  disabled?: boolean;
}

export default function AscRosteringTypeCard({
  title,
  subtitle,
  className,
  disabled = false,
  active = false,
  ...props
}: AscRosteringTypeCardProps) {
  return (
    <button
      className={cn(
        styles.ground,
        disabled && styles.disabled,
        active && styles.active,
        className
      )}
      disabled={false}
      {...props}
    >
      <div className={styles.head}>
        <span className={styles.title}>{title}</span>
        <span className={cn(styles.circle, active && styles.active)} />
      </div>
      <p className={styles.subtitle}>{subtitle}</p>
    </button>
  );
}
